import styled, { css } from 'styled-components';
import { ifNotProp, ifProp, palette } from 'styled-tools';

import { units } from '../../utils/spacing';
import Text from '../Text';
import { TextElements } from '../Text/types';

export const Wrapper = styled.div<{ $fullWidth: boolean }>`
	${ifProp('$fullWidth', 'width: 100%')};
`;

export const StyledLabel = styled(Text).attrs({ el: TextElements.Label })<{ paddingBottom?: string }>`
	${props => (props.paddingBottom ? `padding-bottom: ${props.paddingBottom}; display: inline-block;` : '')}
`;

export const Indicator = styled(Text)`
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%) translateY(-1px);
	height: ${units(2)};
	width: ${units(2)};
	background-color: ${palette('radioIndicatorDeselected')};
	border-radius: 50%;

	&:after {
		content: '';
		position: absolute;
		display: none;
	}
`;

export const Container = styled(Text).attrs({ el: TextElements.Label })<{
	disabled?: boolean;
	$asCard: boolean;
	$fullWidth: boolean;
	checked?: boolean;
	$display: 'flex' | 'block';
	$noMarginBottom?: boolean;
}>`
	display: flex;
	align-items: flex-start;
	position: relative;
	padding-left: ${units(4)};
	margin-bottom: ${p => (p.$noMarginBottom ? 0 : units(1.5))};
	margin-right: ${p => (p.$display === 'flex' ? units(1) : units(3.5))};
	cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	${ifProp('$fullWidth', 'width: 100%')};

	> input {
		position: absolute;
		opacity: 0;
		cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
		height: 0;
		width: 0;
	}

	&:hover > input ~ ${Indicator} {
		${ifNotProp(
			'disabled',
			css`
				background-color: ${palette('radioIndicatorHover')};
			`,
			'cursor: not-allowed;',
		)};
	}

	> input:checked ~ ${Indicator}:after {
		display: block;
	}

	> input:checked ~ ${Indicator} {
		background-color: ${palette('radioIndicatorSelected')};
	}

	${Indicator}:after {
		top: 2px;
		left: 2px;
		width: ${units(1.5)};
		height: ${units(1.5)};
		border-radius: 50%;
		background: ${palette('radioIndicatorSelected')};
		border: 2px solid white;
	}

	${ifProp(
		'$asCard',
		css`
			border: 1px solid ${palette('radioCardBorderDeselected')};
			border-radius: 4px;
			padding-top: calc(0.75rem);
			padding-right: calc(1rem - 1px);
			padding-bottom: calc(0.75rem - 1px);
			padding-left: calc(2.75rem - 1px);
			position: relative;
			${Indicator} {
				transform: translateY(-50%);
				left: 1.25rem;
				box-sizing: border-box;
				border: 2px solid ${palette('radioCardIndicatorBorder')};
				background-color: ${palette('radioCardIndicatorDeselected')};
			}
			> input:checked ~ ${Indicator} {
				border-color: ${palette('radioIndicatorSelected')};
			}
			${Indicator}:after {
				top: 0px;
				left: 0px;
			}
			${ifProp(
				'checked',
				css`
					border-width: 2px;
					border-color: ${palette('radioCardBorderSelected')};

					padding-top: calc(0.75rem - 1px);
					padding-right: calc(1rem - 2px);
					padding-bottom: calc(0.75rem - 2px);
					padding-left: calc(2.75rem - 2px);

					${Indicator} {
						left: calc(1.25rem - 1px);
					}
				`,
			)};
		`,
	)};
`;

export const CardsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const DisplayDiv = styled.div<{ $display: string; $noMarginBottom?: boolean }>`
	display: ${p => p.$display};
	${ifProp('$noMarginBottom', `row-gap: ${units(1.5)}`)};
`;
